// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"ff3b8e20","754":"d9184c34"}[chunkId] + ".chunk.js";
};